import { render, staticRenderFns } from "./PendingEmail.vue?vue&type=template&id=13ad9d65"
import script from "./PendingEmail.vue?vue&type=script&lang=js"
export * from "./PendingEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports